import FormattedMessage from 'I18n/components/FormattedMessage';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { BulbIcon } from 'foundations-assets/icons/components/BulbIcon';
import { RecentlySelectedIcon } from 'foundations-assets/icons/components/RecentlySelectedIcon';
import { RefreshIcon } from 'foundations-assets/icons/components/RefreshIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RecommendationBadge({
  recommendationType
}) {
  switch (recommendationType) {
    case 'RULE':
      return /*#__PURE__*/_jsxs(Ribbon, {
        use: "lorax",
        children: [/*#__PURE__*/_jsx(BulbIcon, {}), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPlaybooks.playbookCard.recommended"
        })]
      });
    case 'FREQUENTLY_USED':
      return /*#__PURE__*/_jsxs(Ribbon, {
        use: "candy-apple",
        children: [/*#__PURE__*/_jsx(RefreshIcon, {}), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPlaybooks.playbookCard.frequentlyUsed"
        })]
      });
    case 'RECENTLY_USED':
      return /*#__PURE__*/_jsxs(Ribbon, {
        use: "calypso",
        children: [/*#__PURE__*/_jsx(RecentlySelectedIcon, {}), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPlaybooks.playbookCard.recentlyUsed"
        })]
      });
    default:
      return null;
  }
}